import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { GetWareHouseList, SetWareHouseList} from "../../store/warehouseAtom";



function WareHouseScroll({ onSelection, viewItemDetails }) {
  const setStockData  = SetWareHouseList();
   const wareHouseData  = GetWareHouseList();
  const [tableData, setTableData] = useState([]);
  const { id } = useParams();

  useEffect(() => {
 
  }, []);

  const onCheckboxClick = async (e, index) => {
    let element = tableData[index];
    tableData[index] = { ...element, checked: e.target.checked };
    await setTableData([...tableData]);
    onSelection(tableData);
  };

  const manageStatus = (statusCode, statusName) => {
    let defaultClass = 'text-blue-600';
    switch (statusCode) {
      case 1: defaultClass = 'text-green-600'; break;
      case 2: defaultClass = 'text-yellow-600'; break;
      case 3: defaultClass = 'text-red-600'; break;
      case 4: defaultClass = 'text-purple-600'; break;
      case 5: defaultClass = 'text-orange-600'; break;
      case 6: defaultClass = 'text-gray-600'; break;
      default: break;
    }
    return (
      <span className={`text-sm font-semibold ${defaultClass}`}>
        {statusName}
      </span>
    );
  };

  return (
    <section className="mt-4 border border-gray-200 rounded-lg bg-white shadow-sm">
      {wareHouseData?.warehouse?.map((info, index) => (
        <div
          key={index}
          onClick={() => viewItemDetails(info?.warehouse_id)}
          className={`flex items-center p-3 border-b border-gray-200 hover:bg-gray-50 cursor-pointer transition-colors duration-200 ${
            Number(id) == info?.warehouse_id ? 'bg-blue-50' : ''
          }`}
        >
          <div className="flex items-center space-x-3 w-full">
        
            <div className="flex-1">
              <div className="font-semibold text-gray-800 text-sm">{info?.warehouse_name}</div>
              <div className="text-sm text-gray-500 italic"> {info?.warehouse_contact_number}</div>
              <div className="text-sm text-gray-600">Status - {info?.warehouse_status}</div>
            </div>
            {/* <div className="text-sm font-semibold text-gray-700">{info?.Bag_Quantity}</div> */}
          </div>
        </div>
      ))}
    </section>
  );
}

export default WareHouseScroll;